import { render, staticRenderFns } from "./PlanAdvantage.vue?vue&type=template&id=363e6462&scoped=true&"
import script from "./PlanAdvantage.vue?vue&type=script&lang=js&"
export * from "./PlanAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./PlanAdvantage.vue?vue&type=style&index=0&id=363e6462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e6462",
  null
  
)

export default component.exports